import * as React from "react";
import { useSelector } from "react-redux";
import { Button, Confirm } from "semantic-ui-react";

import { ApplicationState } from "../../applicationState";
import { PhysioAssessmentFormVersion } from "../models";

interface Props {
    ohCaseId: string;
    taskId: string;
    currentFormVersion: PhysioAssessmentFormVersion;
    onConsultationFormChange: (formVersion: PhysioAssessmentFormVersion) => void;
}

export const PhysioAssessmentFormVersionButton: React.FunctionComponent<Props> = (props: Props) => {
    const [isConfirmationModalOpen, setIsConfirmationModalOpen] = React.useState<boolean>(false); // eslint-disable-line react-hooks/rules-of-hooks
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const ohCase = useSelector((state: ApplicationState) => state.ohCases?.find(c => c.id === props.ohCaseId));
    const task = ohCase?.tasks?.find(t => t.id === props.taskId);

    const onConsultationFormChangeConfirm = () => {
        const formVersion = props.currentFormVersion === PhysioAssessmentFormVersion.ShortAssessment
            ? PhysioAssessmentFormVersion.FullAssessment
            : PhysioAssessmentFormVersion.ShortAssessment;

        setIsConfirmationModalOpen(false);
        props.onConsultationFormChange(formVersion);
    };

    const buttonLabel = props.currentFormVersion === PhysioAssessmentFormVersion.ShortAssessment
        ? "Full Assessment"
        : "Short Assessment";

    if (task.completed || task.cancelled) {
        return null;
    }

    if (props.currentFormVersion === PhysioAssessmentFormVersion.ShortAssessment) {
        return (
            <Button content={buttonLabel} onClick={onConsultationFormChangeConfirm} />
        );
    }

    return (
        <>
            <Button content={buttonLabel} onClick={() => setIsConfirmationModalOpen(true)} />
            <Confirm
                open={isConfirmationModalOpen}
                content={"By doing this action, you will be removing previously written content on this form. Are you sure you want to continue?"}
                onCancel={() => setIsConfirmationModalOpen(false)}
                onConfirm={onConsultationFormChangeConfirm}
            />
        </>
    );
};
